import React, { useState, useEffect } from 'react';
import CustomGraph from './CustomGraph';
import MultiSeriesGraph from '../multiSeriesGraph/MultiSeriesGraph';
import MultiLineGraph from './MultiLineGraph';
import { Paper, Typography, TextField, Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  styledPaper: {
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '2px solid #e6f2ff'
  },
  cardHeader: {
    padding: theme.spacing(2),
    backgroundColor: '#e6f2ff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  graphArea: {
    flexGrow: 1,
    padding: '16px',
    backgroundColor: '#f7fbff',
    minHeight: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  styledTextField: {
    width: '80px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: 'white',
    },
  },
  styledButton: {
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#56a1f1',
    color: 'white',
    height: '40px',
    '&:hover': {
      backgroundColor: '#105cae',
    },
  },
  titleText: {
    color: '#004590',
    fontWeight: 'bold',
    fontSize: '15px'
  }
}));

// Configuration for endpoints that should show analyze button
const ANALYZE_BUTTON_ENDPOINTS = [
  'graphMonthlyRejectionRoute',
  'graphMonthlyProductionRoute'
];

const GraphCard = ({ data, target, updateTarget, onAnalyze }) => {
  const classes = useStyles();

  const handleTargetChange = (e) => {
    const newTarget = Number(e.target.value);
    updateTarget(newTarget);
  };

  const handleUpdateTarget = () => {
    console.log(`Updating target for ${data.title} to ${target}`);
  };

  // Check if analyze button should be shown
  const shouldShowAnalyzeButton = data.endpoint && ANALYZE_BUTTON_ENDPOINTS.includes(data.endpoint);

  return (
    <Paper className={classes.styledPaper}>
      <Box className={classes.cardHeader}>
        <TextField
          type="number"
          value={target}
          onChange={handleTargetChange}
          placeholder="Target"
          variant="outlined"
          size="small"
          className={classes.styledTextField}
        />
        <Typography variant="h6" className={classes.titleText}>
          {data.title}
        </Typography>
        {shouldShowAnalyzeButton ? (
          <Button
            onClick={() => onAnalyze(data.endpoint, data.title, target)}
            size="small"
            className={classes.styledButton}
          >
            Analyze
          </Button>
        ):(
          <div style={{width:'50px'}}></div>
        )}
      </Box>
      <Box className={classes.graphArea}>
        {data.multiSeries ? (
          'graphData' in data && Array.isArray(data.graphData[0]) ? (
            <MultiLineGraph data={data} target={target} />
          ) : (
            <MultiSeriesGraph data={data} target={target} />
          )
        ) : (
          <CustomGraph data={data} target={target} />
        )}
      </Box>
    </Paper>
  );
};

export default GraphCard;

///////////////////////////
//////////////////////